import React from 'react'
import { t } from 'ttag'
import { shallowEqual, useSelector } from 'react-redux'
import { getInterest } from 'ducks/respondent'
import { ProgressBar } from 'components/shared/ProgressBar/ProgressBar'

const InterestBar = () => {
  const { totalAnswers, totalQuestions } = useSelector(
    getInterest,
    shallowEqual,
  )

  return (
    <ProgressBar
      timeLabel={t`Unlimited time`}
      totalAnswers={totalAnswers}
      totalQuestions={totalQuestions}
    />
  )
}

export default InterestBar
